import {
    Component,
    EventEmitter,
    Input,
    Optional,
    Output,
    TemplateRef,
} from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import {
    CmpsPeriodCompareData,
    CmpsPeriodCompareType,
} from './period-compare.metadata';

@Component({
    selector: 'cmps-period-compare',
    template: `
        <div class="cmps-period-compare--container">
            <div class="cmps-period-compare--header">
                <h4 class="cmps-period-compare--title">
                    {{ periodCompareTitle }}
                </h4>
                <button
                    class="cmps-coaching-commitment-detail--close"
                    cmpsIconButton
                    (click)="_dialogRef?.close()"
                >
                    <cmps-icon
                        class="cmps-coaching-commitment-detail--close-button"
                        svgIcon="__internal:close"
                    ></cmps-icon>
                </button>
            </div>
            <div
                class="cmps-period-compare--select"
                [class.cmps-period-compare--day]="
                    daysSelected === _daysSelected.DAYS
                "
                [class.cmps-period-compare--week]="
                    daysSelected === _daysSelected.WEEKS
                "
                [class.cmps-period-compare--month]="
                    daysSelected === _daysSelected.MONTHS
                "
            >
                <div class="cmps-period-compare--select-group">
                    <button
                        class="cmps-period-compare--day-btn"
                        (click)="onClickSelect(_daysSelected.DAYS)"
                    >
                        {{ dayLabel }}
                    </button>
                    <button
                        class="cmps-period-compare--week-btn"
                        (click)="onClickSelect(_daysSelected.WEEKS)"
                    >
                        {{ weekLabel }}
                    </button>
                    <button
                        class="cmps-period-compare--month-btn"
                        (click)="onClickSelect(_daysSelected.MONTHS)"
                    >
                        {{ monthLabel }}
                    </button>
                </div>
            </div>
            <div
                class="cmps-period-compare--input-group"
                [class.cmps-period-compare--day]="
                    daysSelected === _daysSelected.DAYS
                "
                [class.cmps-period-compare--week]="
                    daysSelected === _daysSelected.WEEKS
                "
                [class.cmps-period-compare--month]="
                    daysSelected === _daysSelected.MONTHS
                "
            >
                <div
                    class="cmps-period-compare--selection"
                    *ngIf="daysSelected === _daysSelected.DAYS"
                >
                    <label class="cmps-period-compare--selection-label">{{
                        selectDayLabel
                    }}</label>
                    <ng-container
                        *ngTemplateOutlet="dateSelector"
                    ></ng-container>
                </div>
                <div
                    class="cmps-period-compare--dropdown"
                    *ngIf="
                        daysSelected === _daysSelected.WEEKS ||
                        daysSelected === _daysSelected.MONTHS
                    "
                >
                    <label class="cmps-period-compare--dropdown-label">{{
                        daysSelected === _daysSelected.WEEKS
                            ? selectTheWeekLabel
                            : selectTheMonthLabel
                    }}</label>
                    <select
                        class="cmps-period-compare--dropdown-content"
                        [ngModel]="selectedOption"
                        (ngModelChange)="
                            selectedOption = $event;
                            selectedOptionChange.emit($event)
                        "
                    >
                        <option
                            selected
                            hidden
                        >
                            {{
                                daysSelected === _daysSelected.WEEKS
                                    ? openSelectWeekLabel
                                    : openSelectMonthLabel
                            }}
                        </option>
                        <ng-container
                            *ngIf="daysSelected === _daysSelected.WEEKS"
                        >
                            <option
                                [disabled]="i.disabled"
                                *ngFor="let i of weekData"
                            >
                                {{ i.option }}
                            </option>
                        </ng-container>
                        <ng-container
                            *ngIf="daysSelected === _daysSelected.MONTHS"
                        >
                            <option
                                [disabled]="j.disabled"
                                *ngFor="let j of monthData"
                            >
                                {{ j.option }}
                            </option>
                        </ng-container>
                    </select>
                    <cmps-icon
                        class="cmps-period-compare--chevron-down"
                        svgIcon="__internal:chevron-down"
                    ></cmps-icon>
                </div>
            </div>
            <div class="cmps-period-compare--compare">
                <button
                    cmpsButton
                    (click)="
                        compareAction.emit({
                            periodType: daysSelected,
                            val: selectedOption
                        })
                    "
                >
                    <span cmpsButtonLabel>{{ compareLabel }}</span>
                </button>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-period-compare',
    },
})
export class CmpsPeriodCompareComponent {
    @Input() dayLabel: string;
    @Input() weekLabel: string;
    @Input() monthLabel: string;
    @Input() selectTheWeekLabel: string;
    @Input() selectTheMonthLabel: string;
    @Input() openSelectWeekLabel: string;
    @Input() openSelectMonthLabel: string;
    @Input() dateSelector: TemplateRef<any> | null;
    @Input() periodCompareTitle: string;
    @Input() compareLabel: string;
    @Input() selectDayLabel: string;
    @Input() daysSelected: CmpsPeriodCompareType;
    @Input() weekData: CmpsPeriodCompareData[];
    @Input() monthData: CmpsPeriodCompareData[];

    @Input() selectedOption: string;

    @Output() compareAction: EventEmitter<{
        periodType: CmpsPeriodCompareType;
        val: string;
    }>;

    @Output() selectedOptionChange: EventEmitter<string>;

    /** @private */ _daysSelected = CmpsPeriodCompareType;

    constructor(
        /** @private */ @Optional()
        public readonly _dialogRef: CmpsDialogRef<any, any>,
    ) {
        this.compareAction = new EventEmitter<{
            periodType: CmpsPeriodCompareType;
            val: string;
        }>();
        this.selectedOptionChange = new EventEmitter();
    }

    ngOnInit(): void {
        this.daysSelected = CmpsPeriodCompareType.DAYS;
    }

    onClickSelect(val: CmpsPeriodCompareType): void {
        this.daysSelected = val;
    }

    ngOnDestroy(): void {
        this.compareAction.complete();
        this.selectedOptionChange.complete();
    }
}
